import { render, staticRenderFns } from "./Sensors.vue?vue&type=template&id=12c2d56c"
import script from "./Sensors.vue?vue&type=script&lang=js"
export * from "./Sensors.vue?vue&type=script&lang=js"
import style0 from "./Sensors.vue?vue&type=style&index=0&id=12c2d56c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports